import image from '@/assets/images/manufacturers/climax.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'CLIMAX',
  label: 'Climax',
  image,
}));
